import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import '../css/Person.css';
import { useNavigate } from 'react-router-dom';
import { lerAchados } from '../apis/achados';
import { consultarBoletim, consultarRa } from '../apis/sed';
import { firebase, db, auth, storage, ANO } from '../firebase/logar';
import Swal from 'sweetalert';

// ICONES
import * as IoniconsIcons from 'ionicons/icons';
import { IonIcon } from '@ionic/react';
import { wifiOutline, batteryFullOutline, cellularOutline, arrowForward, settings, personCircle, documentTextOutline, lockOpenOutline, exitOutline, notificationsOutline, calendarNumberOutline, receiptOutline, callOutline, earthOutline, logoAndroid, navigate, phonePortraitOutline, mailOutline, logoFacebook, logoWhatsapp, desktop, desktopOutline, logoInstagram, linkOutline, arrowBack, brushOutline, videocam, videocamOutline, personOutline, idCardOutline } from 'ionicons/icons';
import { verificarNotificacaoResponsavel, verificarNotificacaoServidor } from '../firebase/notificacao';


const Person = () => {
  
  const navigate = useNavigate();

  const abrirTelefone = async (telefone) => {
    window.location.href = await `tel:${telefone}`;
  }

  const abrirEmail = async (email) => {
    window.location.href = await `mailto:${email}`;
  }

  const abrirUrl = async (url) => {
    window.location.href = await `${url}`;
  }


  const copiar = async (texto) => {
    const elementoTemporario = document.createElement("textarea");
    elementoTemporario.value = texto;
    await document.body.appendChild(elementoTemporario);
    await elementoTemporario.select();
    await document.execCommand("copy");
    await document.body.removeChild(elementoTemporario);
    const btn = document.querySelector('.btn-copiar');
    if (btn) {
        btn.innerHTML = 'Copiado!';
    }
    await Swal({
      title: 'Copiado com Sucesso!',
      icon: 'success',
      buttons: {
        confirm: 'Ok',
      },
    })
  }

  // RESPONSAVEL
  const storedImagemPerfil = localStorage.getItem('imagemPerfil');
  const storedResponsavel = localStorage.getItem('responsavel');
  const storedId = localStorage.getItem('id');
  const storedAluno = localStorage.getItem('aluno');
  const storedSerie = localStorage.getItem('serie');
  const storedEmail = localStorage.getItem('email');
  const storedSenha = localStorage.getItem('senha');
  const storedTelefone = localStorage.getItem('telefoneResponsavel');
  const storedTelefoneAluno = localStorage.getItem('telefoneAluno');
  const storedUsuarioSed = localStorage.getItem('usuarioSed');
  const storedSenhaSed = localStorage.getItem('senhaSed');
  const storedNascimentoAluno = localStorage.getItem('nascimentoAluno');

  const [imagemPerfil, setImagemPerfil] = useState(storedImagemPerfil ? storedImagemPerfil : null);
  const [responsavel, setResponsavel] = useState(storedResponsavel ? storedResponsavel : null);
  const [id, setId] = useState(storedId ? storedId : null);
  const [aluno, setAluno] = useState(storedAluno ? storedAluno : null);
  const [serie, setSerie] = useState(storedSerie ? storedSerie : 'inválido');
  const [senha, setSenha] = useState(storedSenha ? storedSenha : 'inválido');
  const [email, setEmail] = useState(storedEmail ? storedEmail : 'inválido');
  const [telefone, setTelefone] = useState(storedTelefone ? storedTelefone : 'inválido');
  const [telefoneAluno, setTelefoneAluno] = useState(storedTelefoneAluno ? storedTelefoneAluno : 'inválido');
  const [usuarioSed, setUsuarioSed] = useState(storedUsuarioSed ? storedUsuarioSed : 'inválido');
  const [senhaSed, setSenhaSed] = useState(storedSenhaSed ? storedSenhaSed : 'inválido');
  const [nascimentoAluno, setNascimentoAluno] = useState(storedNascimentoAluno ? storedNascimentoAluno : 'inválido');
  
  
  const [mostrarDados, setMostrarDados] = useState(false);

  // SERVIDOR
  const storedLogado = localStorage.getItem('logado');
  const storedUsuario = localStorage.getItem('usuario');  
  const storedTema = localStorage.getItem('tema');  
  
  const [logado, setLogado] = useState(storedLogado ? storedLogado.toLowerCase() : null);
  const [usuario, setUsuario] = useState(storedUsuario ? storedUsuario : null);
  const [tema, setTema] = useState(storedTema ? storedTema.toLowerCase() : null);
  
  if (!logado || logado === 'off') {
    localStorage.clear();
    window.location.href = "../logar";
  }

  // RELOGIO
  const [horaAtual, setHoraAtual] = useState(new Date());

  useEffect(() => {
    
    const intervalId = setInterval(() => {
      setHoraAtual(new Date());
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const formatDigit = (digit) => (digit < 10 ? '0' + digit : digit);

  const horas = formatDigit(horaAtual.getHours());
  const minutos = formatDigit(horaAtual.getMinutes());
  const segundos = formatDigit(horaAtual.getSeconds());


  // FUNÇÕES DOS BOTÕES
  const sairDaConta = async () => {
    await Swal({
      title: 'Você deseja sair da conta?',
      icon: 'warning',
      buttons: {
          confirm: 'Sim',
          cancel: 'Não',
      },
  }).then(async (res) => {
    if (res) {
      auth.signOut().then( async () => {
        await localStorage.clear();
        window.location.href = "/logar";
        console.log('Usuário desconectado');
      }).catch((error) => {
        // Lidar com erros durante a desconexão, se houver
        console.error('Erro ao desconectar usuário:', error.message);
      });
    }
  });
  }



  // EDITAR PERFIL
  const [editarTelefoneResponsavel, setEditarTelefoneResponsavel] = useState(telefone);
  const [editarTelefoneAluno, setEditarTelefoneAluno] = useState(telefoneAluno);
  const [editarNascimentoAluno, setEditarNascimentoAluno] = useState(nascimentoAluno);

  const [editarUsuarioSed, setEditarUsuarioSed] = useState(usuarioSed);
  const [editarSenhaSed, setEditarSenhaSed] = useState(senhaSed);

  const [editarSenha, setEditarSenha] = useState("");
  const [editarNovaSenha, setEditarNovaSenha] = useState("");

  const salvarDados = async () => {

    try {
      await db.collection(ANO)
      .doc("responsaveis")
      .collection(responsavel)
      .doc(responsavel).update({
          telefoneResponsavel: editarTelefoneResponsavel,
          telefoneAluno: editarTelefoneAluno,
          ra: editarUsuarioSed,
          usuarioSed: editarUsuarioSed,
          senhaSed: editarSenhaSed,
          nascimentoAluno: editarNascimentoAluno,
      });

      if (nomeImagem && inputArquivoImagem) {
        await db.collection(ANO)
        .doc('carometro')
        .collection('pendente')
        .doc(responsavel).set({
          imagem: nomeImagem,
        });

        await db.collection(ANO)
        .doc("responsaveis")
        .collection(responsavel)
        .doc(responsavel).update({
            imagem: firebase.firestore.FieldValue.delete(),
        });

        // Referência à pasta no Firebase Storage
        const pastaRef = storage.ref(`${ANO}/responsaveis/${responsavel}`);

        try {
          // Excluir todos os arquivos da pasta
          const listaArquivos = await pastaRef.listAll();

          // Verificar a existência e excluir cada arquivo
          const promessasExclusao = listaArquivos.items.map(async (item) => {
            try {
              const metadata = await item.getMetadata();
              if (metadata.size > 0) {
                await item.delete();
                console.log(`Arquivo ${item.name} excluído com sucesso.`);
              } else {
                console.log(`O arquivo ${item.name} não existe.`);
              }
            } catch (error) {
              if (error.code === 'storage/object-not-found') {
                console.log(`O arquivo ${item.name} não existe.`);
              } else {
                console.error(`Erro ao excluir o arquivo ${item.name}:`, error);
              }
            }
          });

          await Promise.all(promessasExclusao);
          console.log('Todos os arquivos da pasta foram excluídos com sucesso.');
        } catch (error) {
          console.error('Erro ao listar arquivos na pasta:', error);
        }

        // Enviar a nova imagem para a pasta
        const storageRef = pastaRef.child(nomeImagem);
        await storageRef.put(inputArquivoImagem);
      }
      
      await localStorage.setItem('telefoneResponsavel', editarTelefoneResponsavel);
      await localStorage.setItem('telefoneAluno', editarTelefoneAluno);
      await localStorage.setItem('usuarioSed', editarUsuarioSed);
      await localStorage.setItem('senhaSed', editarSenhaSed);
      await localStorage.setItem('nascimentoAluno', editarNascimentoAluno);
      
    } catch (error) {
      console.log(error);
    } finally {
      await Swal({
        title: 'Dados salvados com sucesso, aguarde a aprovação da direção da sua foto de perfil!',
        icon: 'success',
        buttons: {
          confirm: 'Ok',
        },
      }).then((res) => {
        window.location.reload();
      });
    }

  }

  const salvarSenha = async () => {
    const senhaAtual = localStorage.getItem('senha');
    try {
      if (editarSenha === senhaAtual) {
        if (editarNovaSenha) {
          if (editarNovaSenha.length >= 6) {
            await localStorage.setItem('senha', editarNovaSenha);
            await db.collection(ANO)
            .doc('responsaveis')
            .collection(responsavel)
            .doc(responsavel)
            .update({
              senha: editarNovaSenha,
            }).then((resposta) => {
              Swal({
                title: 'Dados salvados com Sucesso!',
                icon: 'success',
                buttons: {
                  confirm: 'Ok',
                },
              }).then((res) => {
                window.location.reload();
              })
            })
          } else {
            Swal({
              title: 'A senha precisa de pelo menos 6 digitos!',
              icon: 'error',
              buttons: {
                confirm: 'Ok',
              },
            });
          }
        } else {
          Swal({
            title: 'Digite um nova senha!',
            icon: 'error',
            buttons: {
              confirm: 'Ok',
            },
          });
        }   
      } else {
        Swal({
          title: 'Senha atual inválida!',
          icon: 'error',
          buttons: {
            confirm: 'Ok',
          },
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      /**/
    }

  }

  
  // STATUS NOTIFICAÇÃO
  const [statusNotificacao, setStatusNotificacao] = useState(false);
  
  const statusNotificacaoResponsavel = useCallback( async () => {
    try {
      const resposta = await verificarNotificacaoResponsavel(responsavel, serie);
      setStatusNotificacao(resposta);
    } catch (error) {
      console.log(error);
    }
    
  }, [statusNotificacao]);

  const statusNotificacaoServidor = useCallback( async () => {
    try {
      const resposta = await verificarNotificacaoServidor(logado, usuario);
      setStatusNotificacao(resposta);
    } catch (error) {
      console.log(error);
    }
    
  }, [statusNotificacao]);

  useEffect(() => {
    if (logado === 'responsavel') {
      statusNotificacaoResponsavel();
    } else {
      statusNotificacaoServidor();
    }
  }, []);

  
  // ACHADOS E PERDIDOS
  const [itens, setItens] = useState([]);

  const carregarItens = async () => {
    try {
      const resposta = await lerAchados();
      setItens(resposta);
    } catch {
      console.log('erro nos itens');
    } finally {

    }
  };


  // SED
  const [anoBoletim, setAnoBoletim] = useState(ANO);
  const [raBoletim, setRaBoletim] = useState(usuarioSed !== 'inválido' ? usuarioSed : '');
  const [nascimentoBoletim, setNascimentoBoletim] = useState(nascimentoAluno !== 'inválido' ? nascimentoAluno : '');
  const [boletimHtml, setBoletimHtml] = useState('');
  const [erroBoletim, setErroBoletim] = useState('');
 
  const enviarConsultarBoletim = async () => {
    const RA = raBoletim.slice(0, -1);
    const DIGITO = raBoletim.slice(-1);
    const NASCIMENTO = nascimentoBoletim;
    const ANOboletim = anoBoletim;
    try {
      const resposta = await consultarBoletim(RA, DIGITO, NASCIMENTO, ANOboletim);
      await setBoletimHtml(resposta);
      await setErroBoletim('');
    } catch (error) {
      await setErroBoletim(error);
      await setBoletimHtml('');
      console.log('erro na consulta do Boletim');
    }
  }

  const [nomeRa, setAlunoRa] = useState(aluno);
  const [maeRa, setMaeRa] = useState(responsavel);
  const [nascimentoRa, setNascimentoRa] = useState(nascimentoAluno);
  const [raResposta, setRaResposta] = useState('');
  const [erroRa, setErroRa] = useState('');
 
  const enviarConsultarRa = async () => {
    const ALUNO = nomeRa;
    const MAE = maeRa;
    const NASCIMENTO = nascimentoRa;
    try {
      const resposta = await consultarRa(ALUNO, MAE, NASCIMENTO);
      await setRaResposta(resposta);
      await setErroRa('');
    } catch (error) {
      await setErroRa(error);
      await setRaResposta('');
      console.log('erro na consulta do RA');
    }
  }

  /* VER PARÂMETROS DA URL */

  function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "))
  }

  const urlLocation = window.location.pathname;
  const pagina = getParameterByName('pagina');
  
  useEffect(() => {
  
    const paginaNotifcation = async () => {
      await setMostrarContent(false);
      await setMostrarContato(false);
      await setMostrarRedesSociais(false);
      await setMostrarBaixarApp(false);
      await setMostrarLinksSed(false);
      await setMostrarAchados(false);
      await setMostrarBoletim(false);
      await setMostrarRa(false);
      await setMostrarEditarPerfil(false);
      await setMostrarEditarSenha(false);
      await setMostrarNotification(true);
    }

    const paginaEditarPerfil = async () => {
      await setMostrarContent(false);
      await setMostrarContato(false);
      await setMostrarRedesSociais(false);
      await setMostrarBaixarApp(false);
      await setMostrarLinksSed(false);
      await setMostrarAchados(false);
      await setMostrarBoletim(false);
      await setMostrarRa(false);
      await setMostrarEditarSenha(false);
      await setMostrarNotification(false);
      await setMostrarEditarPerfil(true);
    }

    const paginaBoletim = async () => {
      await setMostrarContent(false);
      await setMostrarContato(false);
      await setMostrarRedesSociais(false);
      await setMostrarBaixarApp(false);
      await setMostrarLinksSed(false);
      await setMostrarAchados(false);
      await setMostrarRa(false);
      await setMostrarEditarSenha(false);
      await setMostrarNotification(false);
      await setMostrarEditarPerfil(false);
      await setMostrarBoletim(true);
    }

    if (pagina === 'notification') {
      paginaNotifcation();
    } else if (pagina === 'editarPerfil') {
      paginaEditarPerfil();
    } else if (pagina === 'boletim') {
      paginaBoletim();
    } else {
      console.error('Função não encontrada:', pagina);
    }

  }, [urlLocation]);
  
  // BOTÕES DA PAGINA
  const [mostrarContent, setMostrarContent] = useState(true);
  const [mostrarNotification, setMostrarNotification] = useState(false);
  const [mostrarBoletim, setMostrarBoletim] = useState(false);
  const [mostrarContato, setMostrarContato] = useState(false);
  const [mostrarRedesSociais, setMostrarRedesSociais] = useState(false);
  const [mostrarBaixarApp, setMostrarBaixarApp] = useState(false);
  const [mostrarLinksSed, setMostrarLinksSed] = useState(false);
  const [mostrarAchados, setMostrarAchados] = useState(false);
  const [mostrarRa, setMostrarRa] = useState(false);
  const [mostrarEditarPerfil, setMostrarEditarPerfil] = useState(false);
  const [mostrarEditarSenha, setMostrarEditarSenha] = useState(false);

  // PAGINAS
  const handleMostrarNotification = async () => {
    await setMostrarContent(false);
    await setMostrarNotification(true);
  }
  
  const handleMostrarContato = async () => {
    await setMostrarContent(false);
    await setMostrarContato(true);
  }

  const handleMostrarRedesSociais = async () => {
    await setMostrarContent(false);
    await setMostrarRedesSociais(true);
  }

  const handleMostrarBaixarApp = async () => {
    await setMostrarContent(false);
    await setMostrarBaixarApp(true);
  }

  const handleMostrarLinksSed = async () => {
    await setMostrarContent(false);
    await setMostrarLinksSed(true);
  }

  const handleMostrarAchados = async () => {
    await setMostrarContent(false);
    await setMostrarAchados(true);
    await carregarItens();
  }

  const handleMostrarBoletim = async () => {
    await setMostrarContent(false);
    await setMostrarBoletim(true);
    await setMostrarRa(false);
  }

  const handleMostrarRa = async () => {
    await setMostrarRa(true);
    await setMostrarBoletim(false);
  }

  const handleMostrarEditarPerfil = async () => {
    await setMostrarEditarPerfil(true);
    await setMostrarContent(false);
  }

  const handleMostrarEditarSenha = async () => {
    await setMostrarEditarSenha(true);
    await setMostrarContent(false);
  }

  const handeVoltarPagina = async () => {
    await setMostrarContent(true);
    await setMostrarContato(false);
    await setMostrarRedesSociais(false);
    await setMostrarBaixarApp(false);
    await setMostrarLinksSed(false);
    await setMostrarAchados(false);
    await setMostrarBoletim(false);
    await setMostrarRa(false);
    await setMostrarEditarPerfil(false);
    await setMostrarEditarSenha(false);
    await setMostrarNotification(false);
  }

  function capitalizar(val) {
    var texto = val;
    // Verifica se a entrada não está vazia
    if (texto.length === 0) {
      return texto;
    }
    // Divide a string em palavras
    var palavras = texto.split(' ');
    // Capitaliza a primeira letra de cada palavra
    for (var i = 0; i < palavras.length; i++) {
      palavras[i] = palavras[i].charAt(0).toUpperCase() + palavras[i].slice(1).toLowerCase();
    }
    // Junta as palavras de volta em uma única string
    var resultado = palavras.join(' ');
    resultado = resultado.replace(/\s+/g, ' ');
    resultado = resultado.trim();

    return resultado;
  }


  // REDEFINIR SENHA 
  const [redefinirSenhaEmail, setInputRedefinirSenhaEmail] = useState(email);

  // REDEFINIR SENHA
  const handleEnviarRedefinirSenha = async () => {
    try {
        if (redefinirSenhaEmail) {
            await auth.sendPasswordResetEmail(redefinirSenhaEmail)
            .then(() => {
                Swal({
                    title: `Link para redefinir sua senha enviado para o email '${redefinirSenhaEmail}'`,
                    icon: 'success',
                    buttons: {
                    confirm: 'Ok',
                    },
                }).then((res) => {
                  handeVoltarPagina();
                })
                console.log('E-mail de redefinição de senha enviado para:', redefinirSenhaEmail);
            })
            .catch((error) => {
                if (error.code === 'auth/invalid-email') {
                    Swal({
                      title: 'Email inválido!',
                      icon: 'error',
                      buttons: {
                        confirm: 'Ok',
                      },
                    });
                } else if (error.code === 'auth/invalid-credential') {
                    Swal({
                      title: 'Email ou senha inválidos!',
                      icon: 'error',
                      buttons: {
                        confirm: 'Ok',
                      },
                    });
                } else if (error.code === 'auth/user-disabled') {
                    Swal({
                      title: 'Sua conta foi desativada por um admin!',
                      icon: 'error',
                      buttons: {
                        confirm: 'Ok',
                      },
                    });
                } else {
                    console.error('Erro ao enviar e-mail de redefinição de senha:', error.message);
                }
            });
        } else {
            Swal({
                title: `Digite um email válido!`,
                icon: 'error',
                buttons: {
                confirm: 'Ok',
                },
            })
        }
        
    } catch (error) {
        console.log(error);
    }
  };

  // FAZER UPLOAD DA FOTO DE PERFIL
  const [nomeImagem, setNomeImagem] = useState('');
  const [inputArquivoImagem, setInputArquivoImagem] = useState(null);

  const handleInputFile = (event) => {
      const arquivo = event.target.files[0];

      // Verifica se um arquivo foi selecionado
      if (arquivo) {
          setNomeImagem(arquivo.name);
          setInputArquivoImagem(arquivo);
      }
  }

  const formatarNascimentoBoletim = (nascimento) => {
     // Remover qualquer caractere que não seja número
     const formattedNascimento = nascimento.replace(/\D/g, '');

     let formattedString = '';
 
     if (formattedNascimento.length <= 2) {
       // Se o comprimento é até 2, significa que estamos digitando o dia
       formattedString = formattedNascimento;
     } else if (formattedNascimento.length <= 4) {
       // Se o comprimento é até 4, significa que estamos digitando o mês
       formattedString = formattedNascimento.substring(0, 2) + '/' + formattedNascimento.substring(2);
     } else {
       // Se o comprimento é maior que 4, significa que estamos digitando o ano
       formattedString = formattedNascimento.substring(0, 2) + '/' + formattedNascimento.substring(2, 4) + '/' + formattedNascimento.substring(4, 8);
     }
 
      setNascimentoBoletim(formattedString);
  }


  const formatarNascimentoRa = (nascimento) => {
    // Remover qualquer caractere que não seja número
    const formattedNascimento = nascimento.replace(/\D/g, '');

    let formattedString = '';

    if (formattedNascimento.length <= 2) {
      // Se o comprimento é até 2, significa que estamos digitando o dia
      formattedString = formattedNascimento;
    } else if (formattedNascimento.length <= 4) {
      // Se o comprimento é até 4, significa que estamos digitando o mês
      formattedString = formattedNascimento.substring(0, 2) + '/' + formattedNascimento.substring(2);
    } else {
      // Se o comprimento é maior que 4, significa que estamos digitando o ano
      formattedString = formattedNascimento.substring(0, 2) + '/' + formattedNascimento.substring(2, 4) + '/' + formattedNascimento.substring(4, 8);
    }

     setNascimentoRa(formattedString);
     setEditarNascimentoAluno(formattedString);
 }


  return (
    <main className="container-person">
      <div className="before">
        <p id="hora">
          {horas}:{minutos}:{segundos}
        </p>

        <div className="flex">
          <IonIcon icon={wifiOutline} />
          <IonIcon icon={cellularOutline} />
          <IonIcon icon={batteryFullOutline} />
        </div>
      </div>

      <header className="local">
        {!mostrarContent && (
          <IonIcon onClick={() => handeVoltarPagina()} icon={arrowBack} />
        )}
        <h1>Perfil</h1>
        <Link to="/app/configuracoes">
          <IonIcon icon={settings} />
        </Link>

      </header>

      {mostrarContent && (
        <section className="content-person">

          <div className="content-dados">

            <div className='imagem'>
              {imagemPerfil ? (
                <img src={imagemPerfil}/>
              ) : (
                <IonIcon icon={IoniconsIcons.personCircleOutline} />
              )}
              <div className='column'>
                <p>Olá, {(logado === 'direcao') ? 'Direção' : (logado === 'coordenacao') ? 'Coordenação' : (logado === 'responsavel') ? 'Responsável' :(logado === 'responsavel') ? 'Responsável' : (logado === 'professor') ? 'Professor(a)' : logado}</p>
                <h1>{logado === 'responsavel' ? responsavel : usuario}</h1>
              </div>
            </div>

            {logado === 'responsavel' ? (
              <IonIcon onClick={handleMostrarEditarPerfil} className='editar' icon={IoniconsIcons.pencilSharp} />
            ) : (
              <div></div>
            )}
            
          </div>
          
          <div className='content-dados-bottom'></div>
            
          <div className="decoracao mb-30">
            <p>Perfil</p>
          </div>

          {statusNotificacao ? (
            <div className="width-100 notificacaoAtivada">
              <h3>Ativado</h3>
              <li onClick={handleMostrarNotification}>
                <IonIcon icon={notificationsOutline} />
                <h1>Notificações</h1>
                <IonIcon icon={arrowForward} />
              </li>
            </div>
          ) : (
            <div className="width-100 notificacaoDesativada">
              <h3>Desativado</h3>
              <li onClick={handleMostrarNotification}>
                <IonIcon icon={notificationsOutline} />
                <h1>Notificações</h1>
                <IonIcon icon={arrowForward} />
              </li>
            </div>
          )}
          
          {logado === 'responsavel' ? (
            <div className="margin-10">
              <li onClick={handleMostrarEditarPerfil}>
                <IonIcon icon={IoniconsIcons.pencil} />
                <h1>Editar Perfil</h1>
                <IonIcon icon={arrowForward} />
              </li>

              <li onClick={handleMostrarEditarSenha}>
                <IonIcon icon={lockOpenOutline} />
                <h1>Redefinir Senha</h1>
                <IonIcon icon={arrowForward} />
              </li>
            </div>
          ) : (
            <div className='margin-5'></div>
          )}
          

          <li onClick={sairDaConta}>
            <IonIcon icon={exitOutline} />
            <h1>Sair da Conta</h1>
            <IonIcon icon={arrowForward} />
          </li>

          <div className="decoracao mt-30 mb-25">
            <p>Serviços</p>
          </div>

          {logado !== 'responsavel' ? (
            <li onClick={() => window.open("https://dashboard-leticia.netlify.app/")}>
              <IonIcon icon={idCardOutline} />
              <h1>Controle Letícia</h1>
              <IonIcon icon={arrowForward} />
            </li>
          ) : (
            <div className='margin5'></div>
          )}

          <li onClick={handleMostrarBoletim}>
            <IonIcon icon={receiptOutline} />
            <h1>Boletim Escolar</h1>
            <IonIcon icon={arrowForward} />
          </li>

          <li onClick={handleMostrarAchados}>
            <IonIcon icon={calendarNumberOutline} />
            <h1>Achados e Perdidos</h1>
            <IonIcon icon={arrowForward} />
          </li>

          <li onClick={handleMostrarLinksSed}>
            <img src="https://sedseecdn.azureedge.net/images/favicon/apple-icon-114x114.png" alt="SED" />
            <h1>Links da SED</h1>
            <IonIcon icon={arrowForward} />
          </li>

          <li onClick={handleMostrarContato}>
            <IonIcon icon={callOutline} />
            <h1>Contato</h1>
            <IonIcon icon={arrowForward} />
          </li>

          <li onClick={handleMostrarRedesSociais}>
            <IonIcon icon={earthOutline} />
            <h1>Redes Socias</h1>
            <IonIcon icon={arrowForward} />
          </li>

          <li onClick={handleMostrarBaixarApp}>
            <IonIcon icon={logoAndroid} />
            <h1>Baixar Aplicativo</h1>
            <IonIcon icon={arrowForward} />
          </li>


        </section>
      )}

      {mostrarNotification && (
        <section className="content-person">
          <div className="lista-person">
            <h1>Notificações</h1>
            <p>Clique no botão abaixo para iniciar o processo:</p>
            <ul className='mt-5 mb-0'>
                <a href="../security/notification" className="width-100">
                  <li className='mb-5'>
                      <IonIcon icon={notificationsOutline} />
                      <h1>Aceitar Notificações</h1>
                      <IonIcon icon={arrowForward} />
                  </li>
                </a>
            </ul>
            <p>Caso tenha dúvida verificar as orientações abaixo:</p>

            <h1>Como aceitar Notificações?</h1>
            <h2>Passo 1: Aceitar notificação no seu navegador web</h2>
            
            <p>
              Verifique se seu navegador web está com as notificações ativadas.
              Entre nas configurações do navegador, vá para as configurações de notificações, 
              e verifique se a opção está ativada. Caso não esteja, ative.
            </p>
            <img src={require('../img/tutorial/passo1.jpg')} alt="Passo 1"/>
            
            <h2>Passo 2: Acessar o site</h2>
            <p>
              No topo da página que o usuario se encontra existe um botão de
              <a href="#"> Aceitar Notificações</a>,
              que ao clicar será direcionado ao nosso aplicativo web dentro 
              do seu navegador. Basta o usuário logar em sua conta novamente 
              e acessar a seguinte url <a href="https://app-leticia-em.netlify.app/security/notification"> "https://app-leticia-em.netlify.app/security/notification"</a>.
            </p>
            <img src={require('../img/tutorial/passo2.jpg')} alt="Passo 2"/>
            
            <h2>Passo 3: Ativando as notificações</h2>
            <p>
              Quando o usuário estiver na página citada acima,
              basta ele clicar no botão 'azul' com o ícone de um sino.
              Irá aparecer um popup (janela) para o usuário permitir
              as notificações.
            </p>
            <div className='margin-top-20'></div>
            <h2>Passo 4: Fim</h2>
            <p>
              Se tudo ocorrer bem, ao ativar as notificações o usuário receberá a seguinte mensagem
              "Obrigado por aceitar as notificações do nosso aplicativo!".
            </p>
            
            <img src={require('../img/tutorial/passo3.jpg')} alt="Passo 3"/>

          </div>
        </section>
      )}

      {mostrarContato && (
        <section className="content-person">
          
          <div className="lista-person">
            
            <h1>Telefones da Escola</h1>

            <ul>

                <h2>Secretaria 1</h2>
                <li  onClick={() => abrirTelefone('551633244623')}>
                    <IonIcon icon={phonePortraitOutline} />
                    <h1>(16) 3324 4623</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <h2>Secretaria 2</h2>
                <li onClick={() => abrirTelefone('551633242256')}>
                  <IonIcon icon={phonePortraitOutline} />
                  <h1>(16) 3324 2256</h1>
                  <IonIcon icon={arrowForward} />    
                </li>

                <h2>Celular da Secretaria</h2>
                <li onClick={() => abrirTelefone('5516991190322')}>
                    <IonIcon icon={phonePortraitOutline} />
                    <h1>(16) 991190322</h1>
                    <IonIcon icon={arrowForward} />
                </li>

            </ul>


            <h1>E-mails da Escola</h1>

            <ul>
                    
                <li onClick={() => abrirEmail('e022123a@educacao.sp.gov.br')}>
                <IonIcon icon={mailOutline} />
                    <h1>Secretaria</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <li onClick={() => abrirEmail('coord.ee.leticia23@gmail.com')}>
                    <IonIcon icon={mailOutline} />
                    <h1>Coordenação</h1>
                    <IonIcon icon={arrowForward} />
                </li>

            </ul>
          </div>
     
        </section>
      )}
      
      {mostrarRedesSociais && (
        <section className="content-person">
          <div className="lista-person">
            <h1>Redes Sociais da Escola</h1>
            <ul>
                <li onClick={() => abrirUrl('https://escola-leticia.netlify.app')}>
                    <IonIcon icon={desktopOutline} />
                    <h1>Website</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <li onClick={() => abrirUrl('https://wa.me/5516991190322')}>
                    <IonIcon icon={logoWhatsapp} />
                    <h1>Whatsapp</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <li onClick={() => abrirUrl('https://www.facebook.com/profile.php?id=61556143874411')}>
                    <IonIcon icon={logoFacebook} />
                    <h1>Facebook</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <li onClick={() => abrirUrl('https://www.instagram.com/e.e.prof_leticia/')}>
                    <IonIcon icon={logoInstagram} />
                    <h1>Instagram</h1>
                    <IonIcon icon={arrowForward} />
                </li>


            </ul>
          </div>
        </section>
      )}

      {mostrarBaixarApp && (
        <section className="content-person">
          <div className="lista-person">
            <h1>Baixar Aplicativo</h1>
            <ul>
                <li onClick={() => copiar('https://play.google.com/store/apps/details?id=com.app.efleticia')}>
                    <IonIcon icon={linkOutline} />
                    <h1>Copiar link do Aplicativo</h1>
                    <IonIcon icon={arrowForward} />
                </li>
                <li onClick={() => abrirUrl('https://play.google.com/store/apps/details?id=com.app.efleticia')}>
                    <IonIcon icon={IoniconsIcons.downloadOutline} />
                    <h1>Baixar Aplicativo</h1>
                    <IonIcon icon={arrowForward} />
                </li>
            </ul>
          </div>
        </section>
      )}

      {mostrarLinksSed && (
        <section className="content-person">
          <div className="lista-person">
            <h1>Links da SED</h1>
            <p>Esses são alguns links rápidos da SED para te ajudar a encontrar o que você deseja</p>
            <ul>
                <li onClick={() => abrirUrl('https://sed.educacao.sp.gov.br/boletim/boletimescolar')}>
                    <IonIcon icon={linkOutline} />
                    <h1>Ver Boletim</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <li onClick={() => abrirUrl('https://sed.educacao.sp.gov.br/NCA/CadastroAluno/ConsultaRAAluno')}>
                    <IonIcon icon={linkOutline} />
                    <h1>Ver Ra</h1>
                    <IonIcon icon={arrowForward} />
                </li>

                <li onClick={() => abrirUrl('https://sed.educacao.sp.gov.br/ConsultaPublica/Consulta')}>
                    <IonIcon icon={linkOutline} />
                    <h1>Ver Consulta Pública</h1>
                    <IonIcon icon={arrowForward} />
                </li>

            </ul>
          </div>
        </section>
      )}

      {mostrarAchados && (
        <section className="content-person">
          <div className="achados">
            <h1>Achados e Perdidos</h1>
            <p>
              Bem-vindo à nossa página de Achados e Perdidos! Aqui, você pode encontrar itens perdidos ou encontrados de forma rápida e fácil.
              Vamos trabalhar juntos para manter nossos pertences seguros e ajudar uns aos outros a recuperar o que é perdido!
            </p>
            {itens.length > 0 ? (
              <div className="itens">
                {itens.map((dado, index) => (
                  <li key={index} className="item">
                    <div className="flex">
                        <h1>{dado["Item Encontrado"]}</h1>
                        <a>{dado["Carimbo de data/hora"]}</a>
                    </div>
                    <p>{dado["Informações"]}</p>
                  </li>
                ))}
              </div>
            ) : (
              <div className="erro-achados">
                  <IonIcon icon={brushOutline} />
                  <h1>Nenhum Material Encontrado</h1>
              </div>
            )}
            

            

          </div>
        </section>
      )}

      {mostrarBoletim && (
        <section className="content-person">
          <div className="boletim">
            <div className="form-tecvit form-person">
                <h1>Consultar Boletim do Aluno</h1>

                <div className="flex">
                  <select defaultValue={ANO} onChange={(e) => setAnoBoletim(e.target.value)} placeholder=" ">
                    <option value={ANO}>{ANO}</option>
                    <option value={ANO - 1}>{ANO - 1}</option>
                    <option value={ANO - 2}>{ANO - 2}</option>
                    <option value={ANO - 3}>{ANO - 3}</option>
                    <option value={ANO - 4}>{ANO - 4}</option>
                    <option value={ANO - 5}>{ANO - 5}</option>
                  </select>
                  <label>Ano Letivo</label>
                </div>

                <div className="flex">
                  <input defaultValue={usuarioSed !== 'inválido' ? usuarioSed : ''} onChange={(e) => setRaBoletim(e.target.value)} placeholder=" " type="text" />
                  <label>Ra + Dígito</label>
                </div>
                
                <div className="flex">
                  <input value={nascimentoBoletim} defaultValue={nascimentoAluno !== 'inválido' ? nascimentoAluno : ''} onChange={(e) => formatarNascimentoBoletim(e.target.value)} placeholder=" " type="text" />
                  <label>Data de Nascimento</label>
                </div>

                <div className='flex'>
                  <button onClick={() => enviarConsultarBoletim()}>Consultar Boletim</button>
                </div>

                <p>Esqueceu o RA? <a onClick={() => handleMostrarRa()}>Consultar</a></p>
            </div>
            {boletimHtml && (
              <div className="divBoletim" dangerouslySetInnerHTML={{ __html: boletimHtml }} />
            )}
            {erroBoletim && (
              <h1>Erro ao consultar boletim</h1>
            )}           
          </div>
        </section>
      )}

      {mostrarRa && (
        <section className="content-person">
          <div className="boletim">
            <div className="form-tecvit form-person">
                <h1>Consultar Ra do Aluno</h1>
            
                <div className="flex">
                  <input defaultValue={aluno !== "inválido" ? aluno : ''} onChange={(e) => setAlunoRa(e.target.value)} placeholder=" " type="text" />
                  <label>Nome do Aluno</label>
                </div>

                <div className="flex">
                  <input defaultValue={responsavel !== "inválido" ? responsavel : ''} onChange={(e) => setMaeRa(e.target.value)} placeholder=" " type="text" />
                  <label>Nome da Mãe</label>
                </div>
                
                <div className="flex">
                  <input value={nascimentoRa} defaultValue={nascimentoAluno !== "inválido" ? nascimentoAluno : ''} onChange={(e) => formatarNascimentoRa(e.target.value)} placeholder=" " type="text" />
                  <label>Data de Nascimento</label>
                </div>

                <div className='flex'>
                  <button onClick={() => enviarConsultarRa()}>Consultar Ra</button>
                </div>
                
                <p>Sabe seu RA? <a onClick={() => handleMostrarBoletim()}>ver boletim</a></p>
            
            </div>
            {raResposta && (
              <div className="divBoletim" dangerouslySetInnerHTML={{ __html: boletimHtml }} />
            )}
            {erroRa && (
              <div>
                <h1>Erro ao consultar o RA</h1>
                <p>{erroRa}</p>
              </div>
              
            )} 
          </div>
        </section>
      )}

      {mostrarEditarPerfil && (
        <section className="content-person">
          <div className="form-tecvit form-person">

            <h1>Dados do Perfil</h1>
            
            <div className="flex input-bloqueado">
              <input defaultValue={responsavel !== 'inválido' ? responsavel : ''} placeholder=" " type="text" readOnly />
              <label>Nome do Responsável</label>
            </div>

            <div className="flex input-bloqueado">
              <input defaultValue={aluno !== 'inválido' ? aluno : ''} placeholder=" " type="text" readOnly />
              <label>Nome do Aluno</label>
            </div>

            <div className="flex input-bloqueado">
              <input defaultValue={serie !== 'inválido' ? serie : ''} placeholder=" " type="text" readOnly />
              <label>Série</label>
            </div>

            <div className="flex input-bloqueado">
              <input defaultValue={email !== 'inválido' ? email : ''} placeholder=" " type="text" readOnly />
              <label>Email</label>
            </div>

            <h1>Editar Perfil</h1>
            
            <div className='flex input-file'>
                <input onChange={(e) => handleInputFile(e)} accept='image/*' type='file' />
                <div className='flex wd-100'>
                    {!nomeImagem ? (
                        <IonIcon icon={IoniconsIcons.cloudUpload}/>
                    ) : (
                        <IonIcon icon={IoniconsIcons.document}/>
                    )}
                    <p>{nomeImagem ? `Arquivo: ${nomeImagem}` : 'Arraste a imagem aqui'}</p>
                </div>
                {!nomeImagem && (
                    <a>Ou clique nesse campo de entrada</a>
                )}
                <label>Foto de Perfil</label>
            </div>
            <span className='color-red mt-10 wd-85'>{nomeImagem.slice(-3) !== 'png' && nomeImagem.slice(-3) !== "jpg" && nomeImagem.slice(-3) !== "svg" && nomeImagem.slice(-4) !== "jpeg" && nomeImagem.slice(-4) !== "webp" && nomeImagem.slice(-4) !== "" ? 'Obs: este arquivo não está no formato certo que é "png, jpg, jpeg, svg ou webp" (Formato de Imagens)' : ''}</span>
             
            <div className="flex">
              <input defaultValue={telefone !== 'inválido' ? telefone : ''} onChange={(e) => setEditarTelefoneResponsavel(e.target.value)} placeholder=" " type="text" />
              <label>Telefone do Responsável</label>
            </div>
            
            <div className="flex">
              <input defaultValue={telefoneAluno !== 'inválido' ? telefoneAluno : ''} onChange={(e) => setEditarTelefoneAluno(e.target.value)} placeholder=" " type="text" />
              <label>Telefone do Aluno</label>
            </div>

            <h1 id='sed'>Dados da Sed <strong>(Opcional)</strong></h1>

            <div className="flex">
              <input defaultValue={usuarioSed !== 'inválido' ? usuarioSed : ''} onChange={(e) => setEditarUsuarioSed(e.target.value)} placeholder=" " type="text" />
              <label>Usuário da Sed</label>
            </div>

            <div className="flex">
              <input defaultValue={senhaSed !== 'inválido' ? senhaSed : ''} onChange={(e) => setEditarSenhaSed(e.target.value)} placeholder=" " type="text" />
              <label>Senha da Sed</label>
            </div>

            <div className="flex">
              <input defaultValue={nascimentoAluno !== 'inválido' ? nascimentoAluno : ''} onChange={(e) => formatarNascimentoRa(e.target.value)} value={editarNascimentoAluno} placeholder=" " type="text" />
              <label>Data de Nascimento do aluno</label>
            </div>

            <div className='flex'>
              <button onClick={() => salvarDados()}>Salvar Dados</button>
            </div>
          
          </div>
        </section>
      )}

      {mostrarEditarSenha && (
        <section className="content-person">
          <div className="form-tecvit form-person">
            
            <h1>Redefinir senha com Email</h1>
            
            <div className="flex">
                <input onChange={(e) => setInputRedefinirSenhaEmail(capitalizar(e.target.value))} placeholder=" " value={redefinirSenhaEmail} type="text" />    
                <label>Digite seu Email</label>
            </div>

            <div className="flex">
                <button onClick={handleEnviarRedefinirSenha}>Redefinir Senha</button>
            </div>

          </div>
        </section>
      )}


    </main>
  );
};


export default Person;